import axios from 'axios';
const baseUrl = '/api/episerver/v3.0/content/';
const createContentDeliveryApiClient = (config) => axios.create({
    headers: {
        'Accept-Language': '*',
        ...config?.headers
    },
    baseURL: baseUrl,
    ...config
});
export default createContentDeliveryApiClient;
